import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  padding: 30px 10px 30px 10px;
  background-color: #f5f7f9;
  #month-title {
    margin-top: 30px;
    border-bottom: solid 1px black;
  }
  .item {
    padding-top: 10px;
    border-bottom: solid 0.5px #b0b6ba;
    padding-bottom: 10px;
    overflow: hidden;
  }
  .small-text {
    font-size: 12px;
    color: #343a40;
  }
  .line {
    display: flex;
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
  }
  @media (min-width: 900px) {
    width: 100%;
    overflow: auto;
    padding: 30px 10px 30px 40px;

    .item {
      border-bottom: solid 0.5px #b0b6ba;
    }
    .wrapper {
      width: 90%;
      float: left;
      padding-bottom: 30px;
    }
  }
`;
